// src/components/auth/Protected.jsx
import React from 'react';
import { useAuth } from '../../context/AuthContext';
import LoginForm from './LoginForm';

export default function Protected({ children }) {
  const { user, boot } = useAuth();
  if (boot) {
    return (
      <div className="min-h-screen flex items-center justify-center text-emerald-700">
        Cargando...
      </div>
    );
  }
  if (!user) return <LoginForm />;
  return children;
}
